import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { ResponsiveService } from '@service/responsive.service';

@Directive({
    selector: '[appDynamicMaxHeight]',
    exportAs: 'appDynamicMaxHeight',
    standalone: false
})
export class DynamicMaxHeightDirective {
    tableRowHeight: number;
    tableRowGap: number;
    tableRowCount: number;
    extraHeight: number;
    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
        private responsive: ResponsiveService,
    ) {}

    init(tableRowHeight: number, tableRowGap: number, tableRowCount: number, extraHeight?: number) {
        this.tableRowGap = tableRowGap;
        this.tableRowHeight = tableRowHeight;
        this.tableRowCount = tableRowCount;
        this.extraHeight = extraHeight;
        this.setMaxHeight();
    }

    @HostListener('window:resize')
    handleWindowResize() {
        if (this.tableRowHeight || this.tableRowGap || this.tableRowCount) {
            this.setMaxHeight();
        }
    }

    setMaxHeight() {
        const tableRowHeight = this.tableRowHeight + this.tableRowGap;
        const tableContainer = this.el.nativeElement.parentElement;
        const allTableRowCount = this.tableRowCount + 2;
        const tableHeight = this.el.nativeElement.offsetHeight;

        if (
            Math.floor(tableContainer.offsetHeight / tableRowHeight) < allTableRowCount &&
            (this.responsive.isLarge() || this.responsive.isXLarge())
        ) {
            const adjustedContainerHeight =
                tableContainer.offsetHeight - (tableRowHeight + this.tableRowGap);
            let calculatedMaxHeight =
                Math.floor(adjustedContainerHeight / tableRowHeight) * tableRowHeight +
                tableRowHeight / 2;
            const remainingRows = this.tableRowCount - tableHeight / tableRowHeight;
            const remainingRowsDec = Math.abs(remainingRows - Math.floor(remainingRows));
            if (remainingRowsDec !== 0.5 || remainingRows <= this.tableRowCount) {
                this.renderer.setStyle(
                    this.el.nativeElement,
                    'maxHeight',
                    `${calculatedMaxHeight}px`,
                );
                this.renderer.removeStyle(this.el.nativeElement, 'height');
            } else {
                this.renderer.removeStyle(this.el.nativeElement, 'maxHeight');
                this.renderer.setStyle(this.el.nativeElement, 'height', `-webkit-fill-available`);
            }
        } else {
            this.renderer.removeStyle(this.el.nativeElement, 'maxHeight');
            this.renderer.setStyle(this.el.nativeElement, 'height', `-webkit-fill-available`);
        }
    }
}
